<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex lg4 v-for="resultado in resultados" :key="resultado.id" >
        <resultado-card :resultado="resultado"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import ResultadoCard from '@/components/ResultadoCard'

export default {
  name: 'resultado-paciente-card',
  data () {
    return {
      resultados: {}
    }
  },
  components: {
    ResultadoCard
  },
  methods: {
    atualizarLista () {
      var params = 'a=a'
      if (this.$route.params.cpf) {
        params += `&cpfPaciente=${this.$route.params.cpf}`
      }
      if (this.$route.params.empresa) {
        params += `&empresa=${this.$route.params.empresa}`
      }
      if (this.$route.params.exame) {
        params += `&exame=${this.$route.params.exame}`
      }
      if (this.$route.params.resultado) {
        params += `&resultado=${this.$route.params.resultado}`
      }
      axios.get(`/rp?${params}`)
        .then(response => {
          this.resultados = response.data.list
          this.$store.commit('changeCabecalho', {cabecalho: response.data.cabecalho})
        })
        .catch(e => {
          this.$router.push({name: 'NotFound'})
        })
    }
  },
  created () {
    this.atualizarLista()
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// ResultadoPacienteCardList.vue?648b773c